import { render, staticRenderFns } from "./Cms.vue?vue&type=template&id=5959fb9b&scoped=true&"
import script from "./Cms.vue?vue&type=script&lang=ts&"
export * from "./Cms.vue?vue&type=script&lang=ts&"
import style0 from "./Cms.vue?vue&type=style&index=0&id=5959fb9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5959fb9b",
  null
  
)

export default component.exports